import { defineStore } from 'pinia'
import { firedataStore } from './firedata'

export const filterStore = defineStore('filterStore', {
  state: () => ({
    friendSessions: [],
    // [{"date":"2022-03-03T11:54:07.392Z","throws":[{"hits":3,"meters":4,"throws":5},{"hits":5,"meters":6,"throws":5},{"hits":0,"meters":8,"throws":0},{"hits":0,"meters":10,"throws":0}]},{"date":"2022-03-06T11:54:16.809Z","throws":[{"hits":2,"meters":4,"throws":5},{"hits":5,"meters":6,"throws":5},{"hits":2,"meters":8,"throws":5},{"hits":0,"meters":10,"throws":0}]}],
    selectedFriend: null,
    watchFriends: false,
  }),
  actions: {
    getFriendSessions(payload) {
      this.selectedFriend = payload;
    }

  },
  getters: {
    lastSession() {
      return this.allSessionsSorted[0]
    },
    allSessionsSorted(state) {
      // console.log(JSON.stringify(useFiredataStore.allSessions));
      const useFiredataStore = firedataStore();
      let allSessions;
      if (state.watchFriends) {
        allSessions = state.friendSessions;
      }
      else allSessions = useFiredataStore.allSessions
      if (!allSessions || !allSessions.length) return []
      if (Array.isArray(useFiredataStore.allSessions)) {
        if (!allSessions.length) return null;
        const dateSortedResult = allSessions.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        return dateSortedResult;
      }
    },
    totalScore(state) {
      const useFiredataStore = firedataStore();
      let allSessions;
      if (state.watchFriends) {
        allSessions = state.friendSessions;
      }
      else allSessions = useFiredataStore.allSessions
      if (!allSessions || !allSessions.length) return []
      const tries = allSessions;
      const allThrows = tries.reduce((arr, t) => arr.concat(t.throws), []);
      const summary = allThrows.reduce((sum, t) => {
        let existingSum = sum.find((o) => o.meters === t.meters);
        let meterSum = existingSum || {
          hits: 0,
          meters: t.meters,
          throws: 0,
        };
        meterSum.hits += t.hits;
        meterSum.throws += t.throws;

        if (!existingSum) sum.push(meterSum);

        return sum;
      }, []);

      return {
        throws: summary,
      };
    },
    daysCalculations(state) {
      const useFiredataStore = firedataStore();
      let allSessions;
      if (state.watchFriends) {
        allSessions = state.friendSessions;
      }
      else allSessions = useFiredataStore.allSessions
      if (!allSessions || !allSessions.length) return []
      const dates = Array.from(
        new Set(
          allSessions.map((t) => {
            return t.date.split("T")[0];
          })
        )
      );
      const result = dates.map((date) => {
        const tries = allSessions.filter((a) => a.date.split("T")[0] === date);
        const allThrows = tries.reduce((arr, t) => arr.concat(t.throws), []);
        const summary = allThrows.reduce((sum, t) => {
          let existingSum = sum.find((o) => o.meters === t.meters);
          let meterSum = existingSum || {
            hits: 0,
            meters: t.meters,
            throws: 0,
          };
          meterSum.hits += t.hits;
          meterSum.throws += t.throws;

          if (!existingSum) sum.push(meterSum);

          return sum;
        }, []);

        return {
          date: date,
          throws: summary,
        };
      });
      const dateSortedResult = result.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      return dateSortedResult;
    }
  },

})
